import dayjs from 'dayjs'
export function eventFormat (event) {
  switch (event) {
    case 'enterPage':
      return '访问了'
    case 'leavePage':
      return '离开了'
    case 'share':
      return '转发了'
    default:
      return '访问了'
  }
}

export function personFormat (user) {
  let userInfo = JSON.parse(window.localStorage.getItem('user'))
  let tarUser = userInfo.name
  return user ? (tarUser === user ? '你的' : `${user}的`) : ''
}

export function materialFormat (materialType) {
  switch (materialType) {
    case 'article':
      return '文章'
    case 'form':
      return '表单'
    case 'H5':
      return 'H5'
    case 'activity':
      return '互动H5'
    case 'friend':
      return '朋友圈'
    case 'case':
      return '案例'
    case 'poster':
      return '海报'
    case 'brochure':
      return '宣传册'
    case 'video-markting':
      return '营销视频'
    default:
      return ''
  }
}

export function platformFormat (platform) {
  switch (platform) {
    case 'WPN':
      return 'H5推广'
    case 'MINI':
      return '小程序'
    default:
      return ''
  }
}

// 每条互动信息的转换，根据返回的数据
export function formatInfo (item) {
  switch (item.event) {
    case 'enterPage':
      return '访问了'
    case 'leavePage':
      return '离开了'
    case 'share':
      return `转发了`
    case 'stay':
      return `在页面停留${item.stayTime}s以上`
    case 'scrollBottom':
      return `浏览到了${materialFormat(item.materialType)}底部`
    case 'submitForm':
      return '提交了表单'
    case 'turnLastPage':
      return '浏览到尾页'
    case 'copy':
      return '复制了'
    case 'save':
      return '保存了'
    case 'grant':
      return '授权了自己的手机号码'
    case 'dial':
      return '拨打了'
    case 'browseEnd':
      return '浏览到了最后'
    case 'like':
      return '点赞了该内容'
    default:
      return ''
  }
}

// 操作实体类型
export function operateEntity (operate) {
  switch (operate) {
    case 'material':
      return '营销资料'
    case 'card':
      return '名片'
    case 'commonMaterial':
      return '普通素材'
    case 'wxNo':
      return '微信号'
    case 'phone':
      return '手机号'
    case 'address':
      return '地址'
    case 'miniMaterial':
      return '小程序资料'
    default:
      return ''
  }
}
export function operateMiniMaterialType (operate) {
  switch (operate) {
    case 1:
      return '文档'
    case 2:
      return '表格'
    case 3:
      return 'PDF'
    case 5:
      return '幻灯片(ppt)'
    case 6:
      return '图片'
    case 7:
      return '音频'
    case 8:
      return '视频'
  }
}

// 图片:1，视频:2，文件:3
// 普通素材类型
export function commonMaterial (type) {
  switch (type) {
    // case 1:
    //   return '图片'
    // case 2:
    //   return '视频'
    // case 3:
    //   return '文件'
    // default:
    //   return ''
    case 6:
      return '图片'
    case 8:
      return '视频'
    default:
      return '文件'
  }
}

export function formatTime (time) {
  let hours = Math.floor(time / 3600)
  let minutes = Math.floor((time % 3600) / 60)
  let seconds = time % 60
  let resultTime = hours
    ? `${hours}时${minutes}分${seconds}秒`
    : minutes
      ? `${minutes}分${seconds}秒`
      : `${seconds}秒`
  return resultTime
}

// 事件发生时间处理 传入 2000-01-01 12:00:00 处理为 【今天 12:00】，【昨天 12:00】
export function formatEventHappenDate (time) {
  let year = dayjs(new Date()).format('YYYY')
  let day = dayjs(new Date()).format('DD')
  let second = dayjs(new Date()).unix()
  let ym = dayjs(new Date()).format('YYYY-MM')
  let ymd = dayjs(new Date()).format('YYYY-MM-DD')
  // itemHm 传入时分 12:00
  let itemHm = time.slice(11, 16)
  // itemSecond 传入秒数
  let itemSecond = dayjs(time).unix()
  // itemDay 传入日期
  let itemDay = time.slice(8, 10)
  // itemMonth 传入月份
  let itemMonth = time.slice(5, 7)
  // itemYear 传入年份
  let itemYear = time.slice(0, 4)
  //  itemYm 传入年月
  let itemYm = time.slice(0, 7)
  // itemYmd 传入年月日
  let itemYmd = time.slice(0, 10)
  // 发生时间处理
  if (itemYmd === ymd) {
    // 今天
    if (second - itemSecond < 60) {
      return `刚刚`
    } else if (second - itemSecond > 60 && second - itemSecond < 3600) {
      let minutes = Math.floor((second - itemSecond) / 60)
      return `${minutes}分钟前`
    } else {
      // 大于一小时
      return `今天 ${itemHm}`
    }
  } else if (itemYm === ym && day - itemDay === 1) {
    return `昨天 ${itemHm}`
  } else if (itemYear === year) {
    return `${itemMonth}-${itemDay} ${itemHm}`
  } else {
    return `${itemYmd} ${itemHm}`
  }
}
// format时间 时间基础格式化 只处理为 【今天】，【昨天】
export function formatDate (item) {
  let year = dayjs(new Date()).format('YYYY')
  let day = dayjs(new Date()).format('DD')
  let ym = dayjs(new Date()).format('YYYY-MM')
  let ymd = dayjs(new Date()).format('YYYY-MM-DD')
  let hm = item.triggerTime.slice(0, 5)
  let itemDay = item.day.slice(8, 10)
  if (item.day === ymd) {
    return `今天`
  } else if (item.month === ym && day - itemDay === 1) {
    return `昨天`
  } else if (item.year === year) {
    return `${item.day.slice(5, 10)}`
  } else {
    return `${item.day}`
  }
}
